/**
 * Payments Service - API client for Paystack fee payments and
 * transaction history
 */
import api from '../utils/api';

const paymentsService = {
  initialize: async (data) => {
    try {
      return await api.post('/api/payments/initialize', data);
    } catch (error) {
      console.error('Error initializing payment:', error);
      throw error;
    }
  },

  getTransaction: async (transactionId) => {
    try {
      return await api.get(`/api/payments/${transactionId}`);
    } catch (error) {
      console.error('Error fetching payment transaction:', error);
      throw error;
    }
  },

  verifyTransaction: async (transactionId) => {
    try {
      return await api.post(`/api/payments/${transactionId}/verify`);
    } catch (error) {
      console.error('Error verifying payment transaction:', error);
      throw error;
    }
  },

  listTransactions: async (params = {}) => {
    try {
      return await api.get('/api/payments/transactions/', { params });
    } catch (error) {
      console.error('Error fetching payment transactions:', error);
      throw error;
    }
  }
};

export default paymentsService;
